import { homeFaqData } from "./homeFaq.data";
import { aboutUsFaqData } from "./aboutUsFaq.data";
import { trimixFaqData } from "./trimixFaq.data";
import { oralMedFaqData } from "./oralMedFaq.data";
import { productDetailFaqData } from "./productDetailFaq.data";

export const homeFaqDataConfig = {
    highlight: "Frequently Asked Questions",
    heading: "Quick answers to common questions",
    items: homeFaqData,
    variant: "standard" as const,
    className: "mt-40",
};

export const aboutUsFaqDataConfig = {
    highlight: "Frequently Asked Questions",
    items: aboutUsFaqData,
    variant: "highlighted" as const,
    highlightedHeadingMain: "Here are some quick answers to common questions about",
    highlightedHeadingAccent: "Defy Medical and erectile dysfunction treatment.",
    className: "mt-40",

};
export const trimixFaqDataConfig = {
    highlight: "Frequently Asked Questions",
    items: trimixFaqData,
    variant: "highlighted" as const,
    highlightedHeadingMain: "Here are some quick answers ",
    highlightedHeadingAccent: "to common questions.",
    className: "mt-40",
};
export const oralMedFaqDataConfig = {
    highlight: "Frequently Asked Questions",
    items: oralMedFaqData,
    variant: "highlighted" as const,
    highlightedHeadingMain: "Quick answers to common questions about ",
    highlightedHeadingAccent: "Defy Medical's erectile dysfunction treatment.",
    className: "mt-40",
};

export const productDetailFaqDataConfig = {
    highlight: "Frequently Asked Questions",
    items: productDetailFaqData,
    variant: "highlighted" as const,
    highlightedHeadingMain: "Quick answers to common questions about",
    highlightedHeadingAccent: "Defy Medical's erectile dysfunction treatment.",
    className: "mt-40",
};